module.exports = __webpack_public_path__ + "static/media/UpennLogo.df9dabf9.PNG";